import { useEffect, useState } from 'react'
import { SMBeamModel, LoadCategory } from '../types'

export type LoadTypeOption = 'UniformLoad' | 'PointLoad' | 'TriangularRight' | 'TriangularLeft' | 'AxialForce' | 'SelfWeight'

export interface LoadFormState
{
  pointLoad: number
  pointLoadPosition: number
  normalForce: number
  normalForcePosition: number
  normalForceEccentricity: number
  uniformIntensity: number
  startIntensity: number
  endIntensity: number
  startPosition: number
  endPosition: number
  axialForceEnd: 'left' | 'right'
  axialForceValue: number
  category: LoadCategory
}

export interface LoadState
{
  selectedSpan: number
  setSelectedSpan: (spanId: number) => void
  selectedLoadType: LoadTypeOption
  setSelectedLoadType: (type: LoadTypeOption) => void
  loadForm: LoadFormState
  setLoadForm: (updater: LoadFormState | ((prev: LoadFormState) => LoadFormState)) => void
  editingLoadId: string | null
  setEditingLoadId: (id: string | null) => void
}

export default function useLoadState(model: SMBeamModel): LoadState
{
  const [selectedSpan, setSelectedSpan] = useState<number>(1)
  const [selectedLoadType, setSelectedLoadType] = useState<LoadTypeOption>('UniformLoad')
  const [editingLoadId, setEditingLoadId] = useState<string | null>(null)
  const [loadForm, setLoadForm] = useState<LoadFormState>({
    pointLoad: -10,
    pointLoadPosition: 2.5,
    normalForce: 0,
    normalForcePosition: 2.5,
    normalForceEccentricity: 0,
    uniformIntensity: -10,
    startIntensity: -20,
    endIntensity: -10,
    startPosition: 0,
    endPosition: 5,
    axialForceEnd: 'right',
    axialForceValue: 50,
    category: 'Variable'
  })

  /* eslint-disable react-hooks/set-state-in-effect -- intentional sync of form defaults when span changes */
  useEffect(() => {
    const span = model.spans.find(current => current.id === selectedSpan)
    if (!span)
    {
      return
    }

    setLoadForm(previous => ({
      ...previous,
      pointLoadPosition: span.length / 2,
      normalForcePosition: span.length / 2,
      endPosition: span.length
    }))
  }, [selectedSpan, model.spans])
  /* eslint-enable react-hooks/set-state-in-effect */

  return {
    selectedSpan,
    setSelectedSpan,
    selectedLoadType,
    setSelectedLoadType,
    loadForm,
    setLoadForm,
    editingLoadId,
    setEditingLoadId
  }
}

